export default __webpack_public_path__ + "static/media/keyHighlight2.19c46fd4.png";